import api from '@/services/Api';
import Versicherung from '@/types/Versicherung';
import { successSwal, warningSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { AxiosResponse } from 'axios';
import { RootState, VersicherungenState } from '@/store/types';

export type VersicherungenFilter = { impfstelle_id?: number; gueltig?: string };
export type LoadVersicherungenPayload = { filter: VersicherungenFilter };
export type UpdateVersicherungPayload = { versicherung: Versicherung; filter: VersicherungenFilter };
export type DeleteVersicherungPayload = { versicherung: Versicherung; filter: VersicherungenFilter };
export type SetVersichungenDialogs = { edit?: boolean };
export type SetVersichungenLoaders = { save?: boolean; delete?: boolean; versicherungen?: boolean };

type Context = ActionContext<VersicherungenState, RootState>;

export const versicherungen: Module<VersicherungenState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            versicherungen: false,
        },
        versicherungen: [],
    },
    actions: {
        loadVersicherungen({ commit }: Context, payload?: LoadVersicherungenPayload): void {
            commit('setLoaders', { versicherungen: true });

            const data = {
                ...payload,
            };

            api.post('verwaltung/versicherungen/load', data)
                .then((response) => commit('setVersicherungen', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoaders', { versicherungen: false }));
        },
        updateVersicherung({ commit, dispatch, rootState }: Context,
                             { versicherung, filter }: UpdateVersicherungPayload): void {
            commit('setLoaders', { save: true });

            const data = {
                impfstelle_id: rootState.authentication.impfstelle_id,
                ...versicherung,
            };

            api.post('verwaltung/versicherungen/speichern', data)
                .then(() => {
                    successSwal('Versicherung', 'gespeichert');
                    dispatch('loadVersicherungen', { filter });
                    commit('setDialogs', { edit: false });
                })
                .catch(console.error)
                .finally(() => commit('setLoaders', { save: false }));
        },
        deleteVersicherung({ commit, dispatch, rootState }: Context,
                             { versicherung: { versicherung_id }, filter }: DeleteVersicherungPayload): void {
            commit('setLoaders', { delete: true });

            const data = {
                impfstelle_id: rootState.authentication.impfstelle_id,
                versicherung_id,
            };

            api.post('verwaltung/versicherungen/loeschen', data)
                .then((response: AxiosResponse) => {
                    if (typeof response.data.body === 'string') {
                        warningSwal('Löschung', response.data.body ?? 'Versicherung ist nicht löschbar.');
                    } else {
                        successSwal('Versicherung', 'gelöscht');
                        dispatch('loadVersicherungen', { filter });
                        commit('setDialogs', { edit: false });
                    }
                })
                .catch(console.error)
                .finally(() => commit('setLoaders', { delete: false }));
        },
    },
    mutations: {
        setVersicherungen(state: VersicherungenState, payload: Partial<Versicherung>[]): void {
            state.versicherungen = payload.map((data) => new Versicherung(data));
        },
        setDialogs(state: VersicherungenState, dialogs: SetVersichungenDialogs): void {
            state.dialogs = {
                ...state.dialogs,
                ...dialogs,
            };
        },
        setLoaders(state: VersicherungenState, loaders: SetVersichungenLoaders): void {
            state.loaders = {
                ...state.loaders,
                ...loaders,
            };
        },
    },
};
